<template>
  <div class="search-form">
    <b-row align-h="start">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.table_search_shipemnt_packingOrder') ||
                  '零售商PO/客户订单编号/订单对应部门名称/关单号外运合同号/海关编号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <el-badge :value="checkedCount" class="item" v-if="!disabled">
              <b-button
                size="sm"
                variant="outline-success"
                class="ml-2"
                @click="$emit('editCustomsBillNo')"
                :disabled="!checkedCount"
              >
                {{ $l('INDEX.btn_editCustomsBillNo') || '编辑海关编号' }}
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
      <b-col cols="5">
        <el-row :gutter="20">
          <el-col :span="16">
            <el-select
              v-model="sortList"
              multiple
              collapse-tags
              size="small"
              style="width:100%"
              :placeholder="
                $l('INDEX.form_placeholder_please_select_the_sorting_field') ||
                  '请选择排序字段'
              "
              clearable
              filterable
              @change="clearSort"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span style="float: left">{{ item.label }}</span>
                <span v-if="item.sortNo" class="radius" style=" ">
                  {{ item.sortNo }}
                </span>
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-dropdown
              :disabled="sortDisabled"
              trigger="click"
              @command="sort"
            >
              <b-button size="sm" variant="outline-primary">
                <i class="el-icon-sort"></i>
                {{ $l('INDEX.products_table_head_sort') || '排序' }}
              </b-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="' ASC'">
                  {{ $l('INDEX.btn_asc') || '升序' }}
                </el-dropdown-item>
                <el-dropdown-item :command="' DESC'">
                  {{ $l('INDEX.btn_desc') || '降序' }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  props: {
    disabled: { type: Boolean, default: false },
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      form: { ...initForm },
      sortList: [],
      options: [
        {
          value: 'retailerPo',
          label: this.$l('INDEX.order_form_label_retailerPo') || '零售商PO',
          sortNo: null,
        },
        {
          value: 'customsNo',
          label:
            this.$l('INDEX.table_label_packingOrder_customsNo') || '关单号',
          sortNo: null,
        },
        {
          value: 'showBookContractNo',
          label:
            this.$l('INDEX.table_label_packingOrder_showBookContractNo') ||
            '外运合同号合集',
          sortNo: null,
        },
      ],
    }
  },
  mounted() {
    this.query()
  },
  computed: {
    sortDisabled() {
      return this.sortList && this.sortList.length > 0 ? false : true
    },
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    sort(type) {
      let sortData = this.sortList
        .filter(Boolean)
        .map((t) => (t += type))
        .join(',')
      this.form.sortData = sortData
      this.$emit('query', this.form)
    },
    clearSort() {
      this.form.sortData = ''
      this.options.forEach((p) => {
        p.sortNo = ''
      })
      let num = 1
      if (!this.sortDisabled) {
        for (const sort of this.sortList) {
          this.options.find((item) => {
            return item.value == sort
          }).sortNo = num++
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
.radius {
  float: right;
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  background: #238ff9;
  color: #ffffff;
}
</style>
